export default function getHrefWithHostname(href) {
  if (href.startsWith("http")) return href;
  return `https://${window.location.hostname}${href}`;
}
